import { AnimatePresence } from 'framer-motion'
import { useMeetingViewModel, type MeetingViewContext } from '../use-meeting-view-model'
import { MeetingAudioPermissionsSurface } from './audio-permissions-card'
import { useMeetingTourPromptSlot } from '../../../components/meeting/meeting-tour/prompt-slot'
import { TourPromptCard } from '../../../components/meeting/meeting-tour/nested/tour-prompt-card'

interface MeetingViewChatInputBeforeProps {
  context: MeetingViewContext
}

/**
 * Chat-input `before` slot for the Meeting View, mounted by `SidepanelChatInput`
 * while a meeting is the top view. Mirrors the shape of `MeetingViewFloatingBarSlot`
 * (`nested/floating-controls.tsx`) — a slot component keyed off the open view's
 * context, resolving the same model. One surface owns everything that renders
 * above the input: permission toggles, the post-grant ready copy, or the
 * meeting-mode notice.
 *
 * The tour's offer sits above those. It only appears once permissions are
 * already granted — a meeting has to have been recorded for there to be a tour
 * to offer — so the two don't compete for the space in practice.
 */
export function MeetingViewChatInputBefore({ context }: MeetingViewChatInputBeforeProps) {
  const model = useMeetingViewModel(context)
  const tourPrompt = useMeetingTourPromptSlot()

  return (
    <>
      <AnimatePresence>
        {tourPrompt && <TourPromptCard onAccept={tourPrompt.onAccept} onDecline={tourPrompt.onDecline} />}
      </AnimatePresence>
      <MeetingAudioPermissionsSurface model={model} />
    </>
  )
}
